import React from "react";
import { photoImg } from "../../assets/index";

const RightAbout = () => {
  return (
    <div className="w-full xl:w-1/2 flex justify-center items-center relative">
      {" "}
      <img
        src={photoImg}
        alt="photoImg"
        className="w-[400px] h-[400px] md:w-[600px] md:h-[600px] xl:w-[750px] xl:h-[800px]"
      ></img>{" "}
    </div>
  );
};

export default RightAbout;
